import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import usePostgreEmailsWidgetData from '../../../../../features/composableAnalytics/hooks/usePostgreEmailsWidgetData';
import CountWithTextCard from '../../../../analytics/components/countWithTextCard';
import { defaultWidgetData } from '../../helper';
import { IPostgreSubmissionDTO } from '../../submissions/types';
import { IPostgreEmailsWidgetProp } from '../types';

const EmailsMetricPostgres = ({ query, title }: IPostgreEmailsWidgetProp) => {
  const { widgetData } = usePostgreEmailsWidgetData<IPostgreSubmissionDTO>(
    query,
    defaultWidgetData
  );
  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      <Grid item xs={2} ml={10}>
        <CountWithTextCard variant="h3" count={widgetData.count as number} fullHeight text="" />
      </Grid>
    </Grid>
  );
};
export default EmailsMetricPostgres;
